import type { RoomDetail } from '../hooks/useCreateBooking';

/**
 * Boat room picker stores diver/guest quantity in `numberOfRooms`
 * (priced per guest). Total guests = sum of those quantities.
 */
export const computeNumberOfGuests = (
  selectedRooms: Pick<RoomDetail, 'numberOfRooms'>[],
): number =>
  selectedRooms.reduce((total, room) => total + (room.numberOfRooms || 0), 0);
